import { render, staticRenderFns } from "./TemplateQuestionTable.vue?vue&type=template&id=709480ee"
import script from "./TemplateQuestionTable.vue?vue&type=script&lang=js"
export * from "./TemplateQuestionTable.vue?vue&type=script&lang=js"
import style0 from "./TemplateQuestionTable.vue?vue&type=style&index=0&id=709480ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports